import { Link, useParams } from "react-router-dom";
import { ROUTES } from "@/config/routes";
import { exportDetailHeadline, exportDetailLead } from "@/domain/export/exportDetailCopy";
import { ExportDetailPanel } from "@/features/exports/components/ExportDetailPanel";
import { useExportJob } from "@/features/exports/hooks/useExportJob";
import { PageHeader } from "@/features/layout/components/PageHeader";

export function ExportDetailPage() {
  const { jobId } = useParams<{ jobId: string }>();
  const { data: job, isLoading } = useExportJob(jobId);

  return (
    <div className="space-y-5">
      <Link to={ROUTES.exports} className="link-quiet text-sm">
        ← Export History
      </Link>

      {isLoading ? <p className="text-sm text-[var(--muted)]">Loading…</p> : null}
      {job ? (
        <>
          <PageHeader
            title={exportDetailHeadline(job)}
            lead={exportDetailLead(job)}
            crumb={
              <Link to={ROUTES.exports} className="link-quiet">
                Export History
              </Link>
            }
          />
          <ExportDetailPanel job={job} />
        </>
      ) : null}
    </div>
  );
}
